import AuthMonitoring from "../Components/AuthMonitoring/AuthMonitoring";

const AuthMonitoringPage = () => {
  return <AuthMonitoring />;
};

export default AuthMonitoringPage;
